import AmexTabbedCarousel from './AmexTabbedCarousel';

export default AmexTabbedCarousel;
